import { useState } from 'react';
import firebase from 'firebase';
import 'firebase/firestore';
import { Link } from 'react-router-dom';

const Join = () => {
	const [name, setName] = useState('');
	const [phone, setPhone] = useState('');
	const [phoneCheck, setPhoneCheck] = useState('');
	const [pinCheck, setPin] = useState('');
	const [pin, setPinCheck] = useState('');
	const firestore = firebase.firestore();
	const users = firestore.collection('users');
	const [homeBtn, setHomeBtn] = useState(false);

	function addUser() {
		phone !== phoneCheck && alert('please confirm your phone numbers match');
		phoneCheck.length !== 12 &&
			alert('please check the length of your phone number and make sure it has a 2547000000 format');
		pin !== pinCheck && alert('please confirm your pin match');

		if (name && phoneCheck.length === 12 && phone === phoneCheck && pinCheck === pin) {
			localStorage.setItem('user-phone', phoneCheck);
			localStorage.setItem('user-name', name);
			localStorage.setItem('pin', pinCheck);

			const user = firestore.doc(`users/${phone}`);
			const amRef=firestore.doc(`users/254786938263`)

			user.set({
				name: name,
				phone: phoneCheck,
				pin: pin,
				createdAt: firebase.firestore.FieldValue.serverTimestamp(),
				followers: [254786938263],
				following: [254786938263],
				caption: 'just do it, God first',
				dp:
					'https://firebasestorage.googleapis.com/v0/b/am-beats-94d37.appspot.com/o/dev%2F1.jpg?alt=media&token=57e265d4-2af3-4af3-a614-20e36c4b9ddd',
			});

			amRef.update({
				followers:firebase.firestore.FieldValue.arrayUnion(phone)
			})

			alert('Welcome to am beats ,you can share your work to the rest of the world');
			setHomeBtn(!homeBtn);
		}
	
	}

	return (
		<div id="join-page" className="page flex-col-evenly">
			<div className="center flex-col-evenly">
				<input type="text" placeholder="Enter name" onChange={(e) => setName(e.target.value)} />
				<input type="number" placeholder="2547..." onChange={(e) => setPhone(e.target.value)} />
				<input type="number" placeholder="confirm 2547..." onChange={(e) => setPhoneCheck(e.target.value)} />
				<input type="number" placeholder="pin" onChange={(e) => setPin(e.target.value)} />
				<input type="number" placeholder="confirm pin" onChange={(e) => setPinCheck(e.target.value)} />
			</div>

			{homeBtn ? (
				<Link to="/Help" className="join-btn flex">
					Go to Home
				</Link>
			) : (
				<span
					className="join-btn flex"
					onClick={(e) => {
						addUser();
					
					}}
				>
					join
				</span>
			)}
		</div>
	);
};

export default Join;
